import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { WorkspaceSettingsDomainFacade } from '@mode/workspace-settings/domain';

export const DowngradedWorkspaceSettingsDomainModule = angular
  .module('downgraded-workspace-settings-domain', [])
  .service('WorkspaceSettingsDomainFacade', downgradeInjectable(WorkspaceSettingsDomainFacade)).name;
